import { Route, Routes } from "react-router-dom";
import Footer from "../Screen/UserMobile/Footer/Footer";
import WatchlistUser from "../Screen/UserMobile/WatchlistUser/Watchlist";

import BuySell from "../Screen/UserMobile/WatchlistUser/BuySell/BuySell";
import BuySellPending from "../Screen/UserMobile/Pending/BuySellPending/BuySellPending";
import AddSymbol from "../Screen/UserMobile/WatchlistUser/AddSymbol/AddSymbol";
import EditSymbol from "../Screen/UserMobile/WatchlistUser/EditSymbol/EditSymbol";
import Details from "../Screen/UserMobile/WatchlistUser/Details/Details";
import MarketDepth from "../Screen/UserMobile/WatchlistUser/MarketDepth/MarketDepth";
import Statistics from "../Screen/UserMobile/WatchlistUser/Statistics/Statistics";
import Chart from "../Screen/UserMobile/WatchlistUser/Chart/Chart";

import Standing from "../Screen/UserMobile/Standing/Standing";
import Trade from "../Screen/UserMobile/Trade/Trade";
import Pending from "../Screen/UserMobile/Pending/Pending";
import Profile from "../Screen/UserMobile/Profile/Profile";

import Settlement from "../Screen/UserMobile/Profile/Settlement/Settlement";
import Ledger from "../Screen/UserMobile/Profile/Ledger/Ledger";
import Rules from "../Screen/UserMobile/Profile/Rules/Rules";
import LoginLogs from "../Screen/UserMobile/Profile/LoginLogs/LoginLogs";
import SymbolLogs from "../Screen/UserMobile/Profile/SymbolLogs/SymbolLogs";
import SymbolQty from "../Screen/UserMobile/Profile/SymbolQty/SymbolQty";

import ChangePassword from "../Screen/UserMobile/Profile/ChangePassword/ChangePassword";

import InterestBill from "../Screen/UserMobile/Profile/InterestBill/InterestBill";
import GenerateBill from "../Screen/UserMobile/Profile/GenerateBill/GenerateBill";

import ProfileUser from "../Screen/UserMobile/Profile/ProfileUser/Profile";

import Deposit from "../Screen/UserMobile/Wallet/Deposit/Deposit";
import Withdrawal from "../Screen/UserMobile/Wallet/Withdrawal/Withdrawal";
import TransactionHistory from "../Screen/UserMobile/Wallet/TransactionHistory/TransactionHistory";

import useSize from "../Utils/useSize/useSize";
import { memo } from "react";

function UserMobile() {
  const windowSize = useSize();
  const userType = Number(localStorage.getItem("user_type") || 7);

  const isUser = userType === 4;

  return (
    <div style={{ height: windowSize[1], backgroundColor: "transparent" }}>
      <div style={{ backgroundColor: "transparent" }}>
        <Routes>
          {/* Default */}

          {isUser && (
            <>
              <Route index element={<WatchlistUser />} />
              <Route path="*" element={<WatchlistUser />} />

              <Route path="/Watchlist" element={<WatchlistUser />} />
              <Route path="/BuySell" element={<BuySell />} />

              <Route path="/BuySellPending" element={<BuySellPending />} />
              <Route path="/AddSymbol" element={<AddSymbol />} />
              <Route path="/EditSymbol" element={<EditSymbol />} />
              <Route path="/Details" element={<Details />} />
              <Route path="/MarketDepth" element={<MarketDepth />} />
              <Route path="/Statistics" element={<Statistics />} />
              <Route path="/Chart" element={<Chart />} />

              <Route path="/Standing" element={<Standing />} />
              <Route path="/Trade" element={<Trade />} />
              <Route path="/Pending" element={<Pending />} />
              <Route path="/Profile" element={<Profile />} />

              <Route path="/Settlement" element={<Settlement />} />
              <Route path="/Ledger" element={<Ledger />} />
              <Route path="/Rules" element={<Rules />} />

              <Route path="/Profile" element={<Profile />} />
              <Route path="/ProfileUser" element={<ProfileUser />} />
              <Route path="/InterestBill" element={<InterestBill />} />
              <Route path="/GenerateBill" element={<GenerateBill />} />

              <Route path="/ChangePassword" element={<ChangePassword />} />
              <Route path="/LoginLogs" element={<LoginLogs />} />
              <Route path="/SymbolLogs" element={<SymbolLogs />} />
              <Route path="/SymbolQty" element={<SymbolQty />} />

              <Route path="/Deposit" element={<Deposit />} />
              <Route path="/Withdrawal" element={<Withdrawal />} />
              <Route path="/TransactionHistory" element={<TransactionHistory />} />
            </>
          )}
        </Routes>
      </div>

      {isUser && <Footer />}
    </div>
  );
}

export default memo(UserMobile);
